/**
 * The Client Type wizard step 1 offers (S1.1 as amended by decision D12, story 6348) — one value,
 * the same list the server holds in OnboardingClientTypes. State is gone: Imperans stores National
 * or Regional, and SSO decides whether it raises a review ticket. International must never appear.
 *
 * The client record edits the same value (bug 5705): the record and step 1 are two presentations of
 * one stored answer, mirrored to the CRM CompanyType column (S1.8). SSO was Australia-only (story
 * 5590's final bullet, bug 5845) until the ruling of 5 Oct 2026: Auckland is run as an SSO covering
 * Auckland East and Auckland West, so both countries offer all three (bug 6491).
 */
export const CLIENT_TYPE_OPTIONS = [
  { label: "National", value: "National" },
  { label: "Regional", value: "Regional" },
  { label: "SSO", value: "SSO" },
];
